import { useSelector } from 'react-redux'
import TagManager from 'react-gtm-module'

const useTracking = () => {
  const { campaignId } = useSelector(state => state.campaignReducers.campaign)
  const { employeeCpf } = useSelector(state => state.loginReducers.loginData)
  const {
    cpCode,
    storeName
  } = useSelector(state => state.storeReducers.store)

  const track = ({ event, parameter, value }) => {
    const objData = {
      ...(value ? { valor: value } : {}),
      ...(parameter ? { parametro: parameter } : {}),
      ...(campaignId ? { campanha: campaignId } : {}),
      ...(employeeCpf ? { login: employeeCpf } : {}),
      ...(cpCode ? { loja: `${cpCode} :: ${storeName}` } : {})
    }

    TagManager.dataLayer({
      dataLayer: {
        event: `e_${event}`,
        ...objData
      }
    })
  }

  return track
}

export default useTracking
